import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { ANALYTIC_INVENTORY_FLOWS_METRIC } from 'modules/reports/interfaces/IReportInventoryFlows';

class AnalyticInventoryFlowsService extends EntityApiService<any> {
  searchAnalytic = (
    metric: ANALYTIC_INVENTORY_FLOWS_METRIC,
    params?: any,
    config?: RequestConfig,
  ) =>
    this.handleResponse(
      ApiClientService.post(this.getPath(`/${metric}`), params, config),
    );
}

export default new AnalyticInventoryFlowsService(
  '/ms-analytics/api/v1/inventory-flows-analytic',
);
